(() => {
  if (window.arousseThemeReady) return;
  window.arousseThemeReady = true;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const cleanups = new Map();
  let panel = null;
  let trigger = null;
  let background = [];
  let focusFrame = 0;
  const visible = element => !!element?.isConnected && !element.closest('[inert], [hidden], [aria-hidden="true"]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility === 'visible' && !element.matches(':disabled');
  const focusable = root => [...root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')].filter(visible);
  const closePanel = (restore = true) => {
    if (!panel) return;
    cancelAnimationFrame(focusFrame);
    const wasMenu = panel.matches('[data-mobile-menu]');
    const previousTrigger = trigger;
    panel.classList.remove('is-open');
    panel.inert = true;
    panel.setAttribute('aria-hidden', 'true');
    previousTrigger?.setAttribute('aria-expanded', 'false');
    if (previousTrigger?.dataset.openLabel) previousTrigger.setAttribute('aria-label', previousTrigger.dataset.openLabel);
    document.querySelector('[data-filter-overlay]')?.classList.remove('is-open');
    background.forEach(([element, previous]) => { element.inert = previous; });
    background = [];
    document.body.classList.remove('menu-open');
    panel = trigger = null;
    if (restore) {
      const selectors = wasMenu ? '.site-header .nav a[href], .site-header .brand' : '.desktop-facets summary, [data-sort-by], .site-header .brand';
      const target = visible(previousTrigger) ? previousTrigger : [...document.querySelectorAll(selectors)].find(visible);
      target?.focus({preventScroll: true});
    }
  };
  const openPanel = (element, button) => {
    if (!element) return;
    closePanel(false);
    panel = element;
    trigger = button;
    panel.inert = false;
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
    trigger?.setAttribute('aria-expanded', 'true');
    if (trigger?.dataset.closeLabel) trigger.setAttribute('aria-label', trigger.dataset.closeLabel);
    document.body.classList.add('menu-open');
    let branch = panel;
    while (branch.parentElement && branch !== document.body) {
      for (const sibling of branch.parentElement.children) {
        if (sibling === branch || sibling.matches('script, style, link, [data-filter-overlay], arousse-newsletter-popup')) continue;
        if (element.matches('[data-mobile-menu]') && sibling.contains(button)) continue;
        background.push([sibling, sibling.inert]);
        sibling.inert = true;
      }
      branch = branch.parentElement;
    }
    if (element.matches('[data-filter-drawer]')) document.querySelector('[data-filter-overlay]')?.classList.add('is-open');
    let attempts = 0;
    const focusPanel = () => {
      if (panel !== element || document.querySelector('dialog[open]')) return;
      const target = focusable(element)[0];
      target?.focus({preventScroll: true});
      if (target && document.activeElement === target && attempts > 0) return;
      if (++attempts < 3) focusFrame = requestAnimationFrame(focusPanel);
      else { element.tabIndex = -1; element.focus({preventScroll: true}); }
    };
    focusPanel();
  };
  document.addEventListener('click', event => {
    const menuButton = event.target.closest('[data-menu-toggle]');
    if (menuButton) {
      const menu = document.querySelector('[data-mobile-menu]');
      if (menu === panel) closePanel(); else openPanel(menu, menuButton);
    }
    const filterButton = event.target.closest('[data-filter-open]');
    if (filterButton) openPanel(document.querySelector('[data-filter-drawer]'), filterButton);
    if (event.target.closest('[data-menu-close], [data-filter-close], [data-filter-overlay]')) closePanel();
    if (event.target.closest('[data-mobile-menu] a[href]')) closePanel(false);
    document.querySelectorAll('.nav .catalog-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (panel && !document.querySelector('dialog[open]')) {
      if (event.key === 'Escape') { event.preventDefault(); closePanel(); return; }
      if (event.key === 'Tab') {
        const items = focusable(panel);
        const first = items[0], last = items.at(-1);
        if (first && (event.shiftKey && document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); (event.shiftKey ? last : first).focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    } else if (event.key === 'Escape') {
      document.querySelectorAll('.catalog-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
    }
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.nav .catalog-menu[open]')) document.querySelectorAll('.nav .catalog-menu[open]').forEach(other => { if (other !== event.target) other.open = false; });
  }, true);
  const desktopMenu = matchMedia('(min-width: 1281px)');
  const desktopFilters = matchMedia('(min-width: 1051px)');
  desktopMenu.addEventListener('change', () => { if (desktopMenu.matches && panel?.matches('[data-mobile-menu]')) closePanel(); });
  desktopFilters.addEventListener('change', () => { if (desktopFilters.matches && panel?.matches('[data-filter-drawer]')) closePanel(); });
  const init = (scope = document) => {
    scope.querySelectorAll('[data-arrivals-carousel]').forEach(root => {
      if (cleanups.has(root)) return;
      const track = root.querySelector('[data-arrivals-track]');
      const controls = root.querySelector('[data-arrivals-controls]');
      const groups = [...root.querySelectorAll('[data-arrivals-group]')];
      const pause = root.querySelector('[data-arrivals-pause]');
      if (!track || !controls || groups.length !== 3 || !pause) return;
      const controller = new AbortController();
      const on = (el, name, fn, options = {}) => el.addEventListener(name, fn, {...options, signal: controller.signal});
      let width = 0, frame = 0, last = 0, offset = 0;
      let paused = reduceMotion.matches, visible = false, hovering = false, touching = false, focused = false;
      const normalize = value => width ? width + ((value - width) % width + width) % width : value;
      const shouldRun = () => width > 0 && visible && !document.hidden && !reduceMotion.matches && !paused && !hovering && !touching && !focused;
      const tick = now => {
        frame = 0;
        if (!shouldRun()) return;
        offset = normalize(offset + Math.min(last ? now - last : 0, 34) * .082);
        track.scrollLeft = offset;
        last = now;
        frame = requestAnimationFrame(tick);
      };
      const sync = () => {
        if (frame) cancelAnimationFrame(frame);
        frame = 0; last = 0; offset = normalize(track.scrollLeft);
        pause.setAttribute('aria-pressed', String(paused));
        pause.textContent = paused ? pause.dataset.playLabel : pause.dataset.pauseLabel;
        pause.disabled = reduceMotion.matches;
        if (shouldRun()) frame = requestAnimationFrame(tick);
      };
      const measure = () => {
        const previous = width;
        width = groups[0].getBoundingClientRect().width;
        offset = width + (previous ? ((track.scrollLeft - previous) / previous) * width : 0);
        track.scrollLeft = normalize(offset);
        controls.hidden = width <= 0;
        sync();
      };
      on(controls, 'click', event => {
        if (event.target.closest('[data-arrivals-pause]')) paused = !paused;
        const button = event.target.closest('[data-arrivals-step]');
        if (button) track.scrollLeft = normalize(track.scrollLeft + Number(button.dataset.arrivalsStep) * track.clientWidth * .85);
        sync();
      });
      on(track, 'scroll', () => {
        if (width && (track.scrollLeft < width || track.scrollLeft >= width * 2)) track.scrollLeft = normalize(track.scrollLeft);
        if (!frame) offset = track.scrollLeft;
      }, {passive: true});
      on(root, 'pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; sync(); } });
      on(root, 'pointerleave', () => { hovering = false; sync(); });
      on(track, 'pointerdown', () => { touching = true; sync(); });
      on(window, 'pointerup', () => { if (touching) { touching = false; sync(); } });
      on(window, 'pointercancel', () => { touching = false; sync(); });
      on(track, 'focusin', event => {
        focused = true; sync();
        if (event.target !== track) event.target.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'instant'});
      });
      on(track, 'focusout', event => { if (!track.contains(event.relatedTarget)) { focused = false; sync(); } });
      on(document, 'visibilitychange', sync);
      on(reduceMotion, 'change', () => { if (reduceMotion.matches) paused = true; sync(); });
      const resize = new ResizeObserver(measure);
      resize.observe(groups[0]); resize.observe(track);
      const intersection = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
      intersection.observe(track);
      measure();
      cleanups.set(root, () => { controller.abort(); resize.disconnect(); intersection.disconnect(); cancelAnimationFrame(frame); });
    });
    scope.querySelectorAll('[data-facet-search]').forEach(input => {
      if (cleanups.has(input)) return;
      const controller = new AbortController();
      const facet = input.closest('.facet');
      const options = [...facet.querySelectorAll('[data-facet-option]')];
      const empty = facet.querySelector('[data-facet-empty]');
      const clear = facet.querySelector('[data-facet-search-clear]');
      const normalize = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const update = () => {
        if (controller.signal.aborted) return;
        const term = normalize(input.value);
        let matches = 0;
        options.forEach(option => {
          const checkbox = option.querySelector('input[type="checkbox"]');
          const name = option.dataset.facetLabel || checkbox?.value || '';
          const match = normalize(name).includes(term);
          if (match) matches++;
          option.hidden = !match && !checkbox?.checked && !option.contains(document.activeElement);
        });
        if (empty) empty.hidden = matches > 0;
        if (clear) clear.hidden = input.value.length === 0;
      };
      const reset = () => { input.value = ''; update(); input.focus({preventScroll: true}); };
      input.addEventListener('input', update, {signal: controller.signal});
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape' && input.value) { event.preventDefault(); event.stopPropagation(); reset(); }
      }, {signal: controller.signal});
      clear?.addEventListener('click', reset, {signal: controller.signal});
      facet.addEventListener('change', update, {signal: controller.signal});
      facet.addEventListener('focusout', () => queueMicrotask(update), {signal: controller.signal});
      update();
      cleanups.set(input, () => controller.abort());
    });
    scope.querySelectorAll('[data-recommendations]').forEach(element => {
      if (cleanups.has(element)) return;
      const controller = new AbortController();
      cleanups.set(element, () => controller.abort());
      fetch(element.dataset.url, {signal: controller.signal}).then(response => {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.text();
      }).then(text => {
        const replacement = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-recommendations]');
        if (element.isConnected && replacement?.innerHTML.trim()) element.innerHTML = replacement.innerHTML;
      }).catch(() => {});
    });
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sort-by]')) event.target.form?.requestSubmit();
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-facets-form]')) return;
    const min = event.target.querySelector('[data-price-min]');
    const max = event.target.querySelector('[data-price-max]');
    max?.setCustomValidity('');
    if (min?.value !== '' && max?.value !== '' && min && max && Number(min.value) > Number(max.value)) {
      event.preventDefault();
      max.setCustomValidity(document.documentElement.dataset.priceRangeError || 'Maximum price must be greater than or equal to minimum price.');
      max.reportValidity();
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-price-min], [data-price-max]')) event.target.closest('form')?.querySelector('[data-price-max]')?.setCustomValidity('');
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (panel && event.target.contains(panel)) closePanel(false);
    for (const [element, cleanup] of cleanups) if (event.target.contains(element)) { cleanup(); cleanups.delete(element); }
  });
  init();
})();
